import useSupportStore from "../../../store/supportStore";
import { formatDateT } from "../../../../../shared/utils/formatters";
import { formatData } from "../../../utils/supportFormatters";

const stepKey = "spVehicle";

const SpVehicleMapper = {
  get: () => {
    const store = useSupportStore.getState();
    return store[stepKey] || {};
  },
  set: (data) => {
    const store = useSupportStore.getState();
    store.updateStepFields(stepKey, data);

    // --- Payload update logic (mirroring spAddressMapper) ---
    const prevLookup = data.prevLookupVehicleReg || {};
    const prevManual = data.prevManualVehicleReg || {};
    const rawFormValues = {
      title: "Change Vehicle",
      "What is your new vehicle registration?": data.prevVehicleRegis,
      ...(prevLookup &&
        Object.keys(prevLookup).length > 0 && {
          "What is the make and model?": `${prevLookup.abiModel ||
            prevLookup.model ||
            ""} ${prevLookup.abiMake || prevLookup.make || ""}`.trim(),
          "What is the year of make?": prevLookup.abiVehicleInfoDesc
            ? prevLookup.abiVehicleInfoDesc.split(",")[0]
            : prevLookup.preVehicleSearch,
          "What is the engine size?": prevLookup.abiVehicleInfoDesc
            ? prevLookup.abiVehicleInfoDesc.split(",")[1]
            : prevLookup.preVehicleSearch,
          "How many seats does the vehicle have including the driver?": prevLookup.abiVehicleInfoDesc
            ? prevLookup.abiVehicleInfoDesc.split(",")[2]
            : prevLookup.preVehicleSearch,
        }),
      ...(prevManual &&
        Object.keys(prevManual).length > 0 && {
          "What is the make and model?": `${prevManual.abiMake ||
            ""} ${prevManual.abiModel || ""}`.trim(),
          "What is the engine size?": prevManual.abiVehicleInfoDesc
            ? prevManual.abiVehicleInfoDesc.split(",")[1]
            : undefined,
          "What is the year of make?": prevManual.abiVehicleInfoDesc
            ? prevManual.abiVehicleInfoDesc.split(",")[0]
            : undefined,
          "How many seats does the vehicle have including the driver?":
            data.prevVehicleDoor?.value,
        }),
      "Will your vehicle continue to be licenced by the existing licencing authority disclosed on your policy?":
        data.exitingLicenseAuth,
      ...(data.exitingLicenseAuth === "No" && {
        "What will be the licencing authority?": data.LicenseAuth?.label,
      }),
      "Will your vehicle be plated for Private hire or Public Hire/Hackney carriage?":
        data.hireType?.label,
      "What is your vehicle body type?": data.bodyType?.label,
      "Is your vehicle a Manual or Automatic?": data.transmissionType?.label,
    };
    const formValues = Object.fromEntries(
      Object.entries(rawFormValues).filter(
        ([, value]) => value !== undefined && value !== null && value !== ""
      )
    );
    const formattedData = formatData(formValues);
    store.updateField("Vehicle_Changes_Details__c", formattedData);
    store.updateField("Vehicle_Changes__c", true);
    store.updateField(
      "Vehicle_Changes_Effective_From__c",
      formatDateT(data.vehicleEffectiveDateTime) || ""
    );
  },
};

export default SpVehicleMapper;
